import React from "react";

export interface ImageProps {
	alt: string;
	classes?: string;
	src?: string;
	style?: Record<string, unknown>;
}

const Image: React.FC<ImageProps> = ({ alt, classes, src, style }) => {
	return <img alt={alt} className={`img-responsive ${classes}`} src={src} style={style} />;
};

export default Image;
